// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { FiMenu, FiX } from "react-icons/fi";


// const Header = () => {
//   const [show, setShow] = useState(false);
//   const [stickyNav, setStickyNav] = useState(false);

//   useEffect(() => {
//     window.onscroll = () => {
//       if (window.pageYOffset < 300) {
//         setStickyNav(false);
//       } else if (window.pageYOffset > 300) {
//         setStickyNav(true);
//       }
//       return () => (window.onscroll = null);
//     };
//   }, []);
//   const MenuControl = () => {
//     setShow(!show);
//   };

//   // let items = document.querySelectorAll(".root__dropdown > a");
//   // for (let i in items) {
//   //   if (items.hasOwnProperty(i)) {
//   //     items[i].onclick = function () {
//   //       this.parentElement.querySelector(".subMenu").classList.toggle("active");
//   //       this.classList.toggle("open");
//   //     };
//   //   }
//   // }

//   const items = document.querySelectorAll(".root__dropdown > a");
//   items.forEach((item) => {
//     const link = item as HTMLAnchorElement; // Преобразование типа
//     link.onclick = function () {
//       const parent = link.parentElement;
//       if (parent) {
//         const submenu = parent.querySelector(".subMenu");
//         if (submenu) {
//           submenu.classList.toggle("active");
//         }
//         link.classList.toggle("open");
//       }
//     };
//   });
//   return (
//     <header>
//       {/* Top Header Section*/}
//       {/* <div className="top__header hidden h-[35px] w-full bg-[#002147] xl:block">
//         <div className="container mx-auto   flex h-full items-center justify-between">
//           <div className="flex h-full items-center gap-4">
//             <div className="flex items-center gap-4">
//               <Fade>
//                 <div className="flex items-center gap-2">
//                   <span>
//                     <FaFolderOpen className="text-sm text-white" />
//                   </span>
//                   <span className="text-xs font-light text-white">
//                     Total Course: 23400
//                   </span>
//                 </div>
//                 <div className="flex items-center">
//                   <span className="text-slate-400 mb-[-1px] text-[14px]">
//                     |
//                   </span>
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <span>
//                     <FaUserTie className="text-sm text-white" />
//                   </span>
//                   <span className="text-xs font-light text-white">
//                     Total Teacher: 320
//                   </span>
//                 </div>

//                 <div className="flex items-center">
//                   <span className="text-slate-400 mb-[-1px] text-[14px]">
//                     |
//                   </span>
//                 </div>
//                 <div className="flex items-center gap-2">
//                   <span>
//                     <FaPhoneAlt className="text-sm text-white" />
//                   </span>
//                   <span className="text-xs font-light text-white">
//                     Hot Line : +88 0181 234567
//                   </span>
//                 </div>
//               </Fade>
//             </div>
//           </div>
//           <div className="flex items-center gap-2">
//             <Fade>
//               <div>
//                 <Link
//                   to={"/register"}
//                   className="flex items-center gap-1.5  rounded-md px-3 py-2 text-white duration-200 ease-in-out hover:text-[#F16126]"
//                 >
//                   <span>
//                     <FaEdit />
//                   </span>
//                   <span className="text-xs ">Register</span>
//                 </Link>
//               </div>
//               <div>
//                 <Link
//                   to={"/login"}
//                   className="flex items-center gap-1.5  rounded-md px-3 py-2 text-white duration-200 ease-in-out hover:text-[#F16126]"
//                 >
//                   <span>
//                     <FaUserEdit />
//                   </span>
//                   <span className="text-xs">Login</span>
//                 </Link>
//               </div>
//             </Fade>
//           </div>
//         </div>
//       </div> */}
      

//       {/* Menu Section */}
//       <div className={stickyNav ? "h-[80px] " : undefined}></div>
//       <div className={stickyNav ? "my__sticky__nav shadow-lg " : undefined}>
//         <div className={show ? " menu-open " : undefined}>
//           <div className="navbar sticky top-0 z-[9999] h-[85px] w-full bg-white">
//             <div className="container mx-auto flex h-[80px] w-full items-center">
//               <div className="flex w-full items-center justify-between">
//                 <div className="header__left">
//                   <div className="logo__section">
//                     <Link to={"/"}>
//                       <img
//                         className="w-[300px]"
//                         src="assets/Images/yellow_logo_pl.png"
//                         alt="Next LMS"
//                       />
//                     </Link>
//                   </div>
//                 </div>

//                 <div className="header__right">
//                   <nav className="lg:block">
//                     {/* <ul className="menu flex items-center gap-0"> */}
//                     <ul className={show ? 'menu flex flex-col justify-start items-start w-[300px] ' : 'menu flex items-center gap-0'}>
//                       {/* <li>
//                         <Link to="/" className="text-xl">Головна</Link>
//                       </li> */}

//                       <li>
//                         <Link 
//                           to="/" 
//                           className="text-xl border border-black py-2 px-6 rounded-full hover:bg-gray-800 hover:text-white transition duration-300"
//                         >
//                           Головна
//                         </Link>
//                       </li>
//                       <li>
//                         <Link 
//                           to="/game" 
//                           className="text-xl border border-black py-2 px-6 rounded-full hover:bg-gray-800 hover:text-white transition duration-300"
//                         >
//                           Вакансії
//                         </Link>
//                       </li>
                      
//                       <li>
//                         <Link 
//                           to="/future-teacher" 
//                           className="text-xl border border-black py-2 px-6 rounded-full hover:bg-gray-800 hover:text-white transition duration-300"
//                         >
//                           Стати викладачем
//                         </Link>
//                       </li>
//                       {/* <li>
//                         <Link 
//                           to="/donate" 
//                           className="text-xl border border-black py-2 px-6 rounded-full hover:bg-gray-800 hover:text-white transition duration-300"
//                         >
//                           Підтримати
//                         </Link>
//                       </li> */}
//                       <li>
//                         <Link 
//                           to="/loginn" 
//                           className="text-xl border-2 border-[#F16126] text-[#eb6a42] py-2 px-6 rounded-full hover:bg-[#F16126] hover:text-white transition duration-300"
//                         >
//                           Увійти
//                         </Link>
//                       </li>
//                       <li>
//                         <Link 
//                           to="/registerr" 
//                           className="text-xl border-2 border-[#F16126] text-[#eb6a42] py-2 px-6 rounded-full hover:bg-[#F16126] hover:text-white transition duration-300"
//                         >
//                           Зареєструватись
//                         </Link>
//                       </li>
                      
//                     </ul>
//                   </nav>
//                   {/* Start Humbugger Menu  */}
//                   <button className="HumbuggerMenu block xl:hidden">
//                     <span
//                       onClick={MenuControl}
//                       className="menuOpenTrigger text-white"
//                     >
//                       <FiMenu />
//                     </span>
//                   </button>
//                   <button className="close-menu block xl:hidden">
//                     <span onClick={MenuControl} className="MenuCloseTrigger">
//                       <FiX />
//                     </span>
//                   </button>
//                   {/* End Humbugger Menu  */}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;




import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";
import axios from "axios";
import { useAppDispatch, useAppSelector } from "../../../hooks/reducer";
import { fetchUserData } from "../../../store/slices/auth";

const Header = () => {
  const dispatch = useAppDispatch();

  const user = useAppSelector((state) => state.authReducer.data?.user);
  const isAuth = !!user;

  const [show, setShow] = useState(false);
  const [stickyNav, setStickyNav] = useState(false);

  // Профільне меню
  const [profileOpen, setProfileOpen] = useState(false);
  const profileRef = useRef<HTMLDivElement>(null);

  // Перевірка авторизації
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token && !user) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
      dispatch(fetchUserData());
    }
  }, [dispatch, user]);

  // Sticky navbar
  useEffect(() => {
    const onScroll = () => setStickyNav(window.pageYOffset > 300);
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Обробка root dropdown
  useEffect(() => {
    const items = document.querySelectorAll(".root__dropdown > a");
    const cleanupFns: Array<() => void> = [];

    items.forEach((item) => {
      const link = item as HTMLAnchorElement;

      const handleClick = (e: Event) => {
        e.preventDefault();
        const parent = link.parentElement;
        if (!parent) return;

        const submenu = parent.querySelector(".subMenu");
        submenu?.classList.toggle("active");
        link.classList.toggle("open");
      };

      link.addEventListener("click", handleClick);
      cleanupFns.push(() => link.removeEventListener("click", handleClick));
    });

    return () => cleanupFns.forEach((fn) => fn());
  }, []);

  // Закриття профільного меню по кліку поза ним
  useEffect(() => {
    const onClickOutside = (e: MouseEvent) => {
      if (!profileRef.current) return;
      if (!profileRef.current.contains(e.target as Node)) {
        setProfileOpen(false);
      }
    };

    document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, []);

  const MenuControl = () => setShow((prev) => !prev);

  const closeMobileMenu = () => {
    setShow(false);
    setProfileOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    delete axios.defaults.headers.common["Authorization"];
    setProfileOpen(false);
    setShow(false);
    window.location.href = "/start";
  };

  const displayName = user?.username?.trim() || "Користувач";
  const avatarLetter = displayName.charAt(0).toUpperCase();

  const navLinkClass =
    "relative inline-flex items-center whitespace-nowrap text-[16px] font-black uppercase leading-none tracking-[-0.05em] text-black transition duration-200 hover:text-[#f5c400] xl:text-[17px] 2xl:text-[19px]";

  const mojuLinkClass =
    "relative inline-flex items-center whitespace-nowrap text-[21px] font-black uppercase italic leading-none tracking-[-0.08em] text-[#ffd400] drop-shadow-[1px_1px_0_#000] transition duration-200 hover:scale-105 xl:text-[23px] 2xl:text-[25px]";

  const mobileNavLinkClass =
    "flex min-h-[48px] items-center rounded-xl border-2 border-black bg-white px-3 text-[15px] font-black uppercase leading-none tracking-[-0.04em] text-black shadow-[3px_3px_0_#ffe100] transition active:translate-y-0.5 active:shadow-[1px_1px_0_#ffe100]";

  const mobileMojuLinkClass =
    "flex min-h-[48px] items-center rounded-xl border-2 border-black bg-[#fff5a8] px-3 text-[19px] font-black uppercase italic leading-none tracking-[-0.08em] text-[#ffd400] shadow-[3px_3px_0_#000] drop-shadow-[1px_1px_0_#000] transition active:translate-y-0.5 active:shadow-[1px_1px_0_#000]";

  const authBtnClass =
    "inline-flex min-w-[86px] items-center justify-center rounded-[9px] border-2 border-black bg-[#ffe100] px-3 py-1.5 text-[14px] font-black uppercase leading-none text-black shadow-[3px_3px_0_#000] transition duration-200 hover:-translate-y-0.5 hover:bg-[#ffef4d] hover:shadow-[4px_4px_0_#000] active:translate-y-0 active:shadow-[2px_2px_0_#000] 2xl:min-w-[98px] 2xl:px-4 2xl:py-2 2xl:text-[15px]";

  const profileBtnClass =
    "group inline-flex items-center gap-3 rounded-[14px] border-2 border-black bg-white px-4 py-2 text-[15px] font-black uppercase text-black shadow-[3px_3px_0_#f5c400] transition duration-200 hover:-translate-y-0.5 hover:bg-[#ffe100]";

  const publicNavItems = [
    { label: "Робота", to: "/vacancies" },
    { label: "Партнерам", to: "/start#partners" },
    { label: "Курси", to: "/courses" },
    { label: "Консультації", to: "/consultations" },
    { label: "Новини", to: "/news" },
    { label: "Можу!", to: "/moju", accent: true },
    { label: "Хто ми?", to: "/about" },
  ];

  return (
    <header>
      <div className={stickyNav ? "h-[96px]" : undefined} />
      <div className={stickyNav ? "my__sticky__nav shadow-lg" : undefined}>
        <div className={show ? "menu-open" : undefined}>
          <div className="navbar sticky top-0 z-[9999] h-auto min-h-[76px] w-full bg-white shadow-sm xl:min-h-[124px]">
            <div className="mx-auto flex min-h-[74px] w-full max-w-[1560px] items-center px-4 sm:px-6 lg:px-10 xl:min-h-[118px]">
              <div className="flex w-full items-center justify-between gap-5 xl:grid xl:grid-cols-[260px_minmax(0,1fr)] xl:grid-rows-[48px_58px] xl:items-center xl:gap-x-8 xl:gap-y-0 2xl:grid-cols-[300px_minmax(0,1fr)]">
                {/* Logo */}
                <div className="header__left flex-shrink-0 xl:row-span-2">
                  <div className="logo__section">
                    <Link to="/start" onClick={closeMobileMenu}>
                      <img
                        className="w-[205px] sm:w-[245px] lg:w-[285px] xl:w-[315px] 2xl:w-[350px]"
                        src="/assets/Images/yellow_logo_pl.png"
                        alt="Yellow Hub Харків - Єловхаб"
                      />
                    </Link>
                  </div>
                </div>

                {/* Menu */}
                <div className="header__right flex items-center xl:contents">
                  <div className="hidden items-center justify-end gap-5 self-end xl:col-start-2 xl:row-start-1 xl:flex">
                    {!isAuth ? (
                      <>
                        <Link
                          to="/registerr"
                          onClick={closeMobileMenu}
                          className={authBtnClass}
                        >
                          Реєстрація
                        </Link>
                        <Link
                          to="/loginn"
                          onClick={closeMobileMenu}
                          className={authBtnClass}
                        >
                          Вхід
                        </Link>
                      </>
                    ) : (
                      <div
                        ref={profileRef}
                        className="relative"
                        onMouseEnter={() => setProfileOpen(true)}
                        onMouseLeave={() => setProfileOpen(false)}
                      >
                        <button
                          type="button"
                          onClick={() => setProfileOpen((prev) => !prev)}
                          className={profileBtnClass}
                        >
                          <span className="hidden max-w-[150px] truncate lg:block">
                            {displayName}
                          </span>

                          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#ffe100] text-black font-black transition group-hover:bg-black group-hover:text-[#ffe100]">
                            {avatarLetter}
                          </span>
                        </button>

                        <div
                          className={`absolute right-0 mt-3 w-56 overflow-hidden rounded-2xl border-2 border-black bg-white shadow-[5px_5px_0_#ffe100] transition-all duration-150 z-[10001] ${
                            profileOpen
                              ? "opacity-100 visible translate-y-0"
                              : "opacity-0 invisible -translate-y-1"
                          }`}
                        >
                          <Link
                            to="/my-courselist"
                            onClick={closeMobileMenu}
                            className="block px-4 py-3 text-sm font-bold text-gray-900 hover:bg-[#fff7bf]"
                          >
                            Кабінет
                          </Link>

                          <button
                            type="button"
                            onClick={handleLogout}
                            className="block w-full px-4 py-3 text-left text-sm font-bold text-red-600 hover:bg-red-50"
                          >
                            Вийти
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  <nav className="hidden self-start xl:col-start-2 xl:row-start-2 xl:block">
                    <ul
                      className="menu flex items-center justify-end gap-4 2xl:gap-6"
                    >
                      {publicNavItems.map((item) => (
                        <li key={item.label}>
                          <Link
                            to={item.to}
                            onClick={closeMobileMenu}
                            className={item.accent ? mojuLinkClass : navLinkClass}
                          >
                            {item.accent ? (
                              <span className="notranslate" translate="no">
                                МОЖУ!
                              </span>
                            ) : (
                              item.label
                            )}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </nav>

                  {/* Mobile buttons */}
                  <button
                    type="button"
                    className="inline-flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl border-2 border-black bg-[#ffe100] text-2xl text-black shadow-[3px_3px_0_#000] transition active:translate-y-0.5 active:shadow-[1px_1px_0_#000] sm:h-12 sm:w-12 xl:hidden"
                    onClick={MenuControl}
                    aria-label={show ? "Закрити меню" : "Відкрити меню"}
                  >
                    {show ? <FiX /> : <FiMenu />}
                  </button>
                </div>
              </div>
            </div>

            {show && (
              <div className="absolute left-3 right-3 top-full z-[10000] mt-2 rounded-2xl border-2 border-black bg-white p-4 shadow-[7px_7px_0_#ffe100] xl:hidden">
                <ul className="grid grid-cols-2 gap-3">
                  {publicNavItems.map((item) => (
                    <li
                      key={item.label}
                      className={item.label === "Консультації" ? "col-span-2 sm:col-span-1" : undefined}
                    >
                      <Link
                        to={item.to}
                        onClick={closeMobileMenu}
                        className={item.accent ? mobileMojuLinkClass : mobileNavLinkClass}
                      >
                        {item.accent ? (
                          <span className="notranslate" translate="no">
                            МОЖУ!
                          </span>
                        ) : (
                          item.label
                        )}
                      </Link>
                    </li>
                  ))}

                  {!isAuth ? (
                    <li className="col-span-2 grid grid-cols-2 gap-3 pt-1">
                      <Link
                        to="/registerr"
                        onClick={closeMobileMenu}
                        className={`${authBtnClass} w-full`}
                      >
                        Реєстрація
                      </Link>
                      <Link
                        to="/loginn"
                        onClick={closeMobileMenu}
                        className={`${authBtnClass} w-full`}
                      >
                        Вхід
                      </Link>
                    </li>
                  ) : (
                    <li className="col-span-2 grid grid-cols-2 gap-3 pt-1">
                      <Link
                        to="/my-courselist"
                        onClick={closeMobileMenu}
                        className={`${authBtnClass} w-full`}
                      >
                        Кабінет
                      </Link>
                      <button
                        type="button"
                        onClick={handleLogout}
                        className="inline-flex items-center justify-center rounded-[10px] border-2 border-black bg-white px-4 py-2 text-[16px] font-black uppercase leading-none text-red-600 shadow-[3px_3px_0_#000] transition duration-200 hover:-translate-y-0.5 hover:bg-red-50"
                      >
                        Вийти
                      </button>
                    </li>
                  )}
                </ul>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

